<script lang="ts">
  import Separator from "$shared/components/Separator.svelte";
  import { onMount } from "svelte";
  import { withApi } from "$shared/lib/api-parkito";
  import { Toast } from "$components";
  import type { SpotShare } from "../../../apis/parkito";
  import { querystring, replace } from "svelte-spa-router";
  import CardInline from "$shared/components/CardInline.svelte";
  import CustomButton from "$shared/components/CustomButton.svelte";
  import LoadingIndicator from "$shared/components/LoadingIndicator.svelte";
  import { fade } from "svelte/transition";
  import ErrorCloud from "$shared/components/ErrorCloud.svelte";

  export let params: { id: string };

  let code: string | null;
  let spotShare: SpotShare | undefined = undefined;
  let isLoading: boolean = false;

  onMount(() => {
    if (import.meta.env.DEV) console.log("Accept spot share mounted.");
    code = new URLSearchParams($querystring).get("code");
    getSpotShare();
  });

  const getSpotShare = async () => {
    isLoading = true;
    const res = await withApi((api) => {
      return api.getSpotShare(params.id);
    });
    isLoading = false;

    if (res.isOk()) {
      spotShare = res.value;
    } else {
      Toast.error("Kunde inte hitta platsdelning.");
    }
  };

  const acceptOffer = async () => {
    const res = await withApi((api) => {
      return api.acceptSpotShare(params.id, code ?? "");
    });

    if (res.isOk()) {
      Toast.info("Platsdelning accepterad.");
      window.location.hash = "/";
      window.location.reload();
    } else {
      Toast.error("Operationen misslyckades. Försök igen senare.");
    }
  };
</script>

<div in:fade={{ duration: 150 }}>
  <div class="px-[24px] py-[24px] max-mobile:px-[8px] max-mobile:py-[8px]">
    <h2 class="text-[#181818] text-[17px] -mt-[30px] inline relative">
      Erbjudande om platsdelning
    </h2>
  </div>
  <Separator customClass="max-mobile:hidden" />

  <div
    class="max-w-[680px] p-[32px] max-mobile:px-[8px] text-[14px] text-[#606060]"
  >
    <div>
      {#if isLoading}
        <LoadingIndicator visible={true} customClass="py-[96px]" />
      {:else if spotShare}
        <CardInline title="Besvara erbjudande">
          <div class="px-[16px]">
            <p>
              <strong>{spotShare.grantedBy.email}</strong> erbjuder att dela sin
              parkeringsplats med dig. Vill du acceptera erbjudandet?
            </p>
            <p class="pt-[8px]">
              Erbjudandet gäller anläggning <strong>{
                spotShare.siteName
              }</strong>
              med plats
              <strong>
                nr {spotShare.spot.numeric_name} ({
                  spotShare.spot.name
                })</strong>.
            </p>
            <div class="flex pt-[24px] justify-end">
              <CustomButton
                type="primary"
                onClick={acceptOffer}
                customClass="w-[200px]"
              >Acceptera</CustomButton>
            </div>
          </div>
        </CardInline>
      {:else}
        <ErrorCloud
          altMessage="link-not-available"
          title="Ogiltig inbjudan"
          text="Erbjudandet du försöker visa är inte längre giltigt. Vänligen kontakta support vid frågor."
        />
      {/if}
    </div>
  </div>
</div>
